// Modules
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import $ from 'jquery';

// Actions
import { actions } from './actions';

// Components
import { RemoveButton } from 'components/widgets/buttons';
import SVG from 'components/widgets/icons/svg';


// Component
export default function Alert({ alert, ...props }) {
  const { className, type } = alert;

  const classes = classNames(className, 'alert', `alert-${type}`);

  const svgSrc = {
    danger: 'svg/warning.svg',
    warning: 'svg/warning.svg',
    success: 'svg/check.svg'
  };

  return (
    <div
      {...props}
      className={classes}
      onClick={(e) => {
        // If the user clicked a link in the alert, dismiss the alert
        if ($(e.target).is('a')) actions.removeAlert(alert.id);
      }}
    >
      <SVG src={svgSrc[type]} />
      <span className="multiline-inline">
        <strong>{alert.title}</strong>
        {alert.subtitle}
      </span>
      <RemoveButton className="alert-remove" onClick={() => actions.removeAlert(alert.id)} />
    </div>
  );
}

// Prop types
Alert.propTypes = {
  alert: PropTypes.object
};
